import React from "react";
import { ReportPanel } from "components/PortalDashboard";
import { PortalDateInput } from "components/PortalDatePicker";
import useExportBookMetrics from "api/AdminDashboardResource/useExportBookMetrics";

const BookMetricsExportPanel = () => {
	const { mutate: exportMetrics, isLoading } = useExportBookMetrics();
	const [from, setFrom] = React.useState("");
	const [to, setTo] = React.useState("");

	const onSubmit = (e) => {
		e.preventDefault();
		// if (!from || !to) return;
		exportMetrics({ from, to });
	};

	return (
		<ReportPanel title="Export book visits" description="Download a report for further analysis.">
			<form
				onSubmit={onSubmit}
				className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end"
			>
				<div>
					<label htmlFor="book-visits-from" className="block text-sm text-gray-600 mb-1">From date</label>
					<PortalDateInput
                        label="From date"
                        id="book-visits-from"
                        max={to || undefined}
						value={from}
						onChange={(e) => setFrom(e.target.value)}
					/>
				</div>
				<div>
					<label htmlFor="book-visits-to" className="block text-sm text-gray-600 mb-1">To date</label>
					<PortalDateInput
                        label="To date"
                        id="book-visits-to"
                        min={from || undefined}
						value={to}
						onChange={(e) => setTo(e.target.value)}
					/>
				</div>
				<div className="md:col-span-2">
					<button
						type="submit"
						disabled={isLoading}
						className="portal-button portal-button-primary disabled:opacity-50"
					>
						{isLoading ? "Generating..." : "Download Excel"}
					</button>
				</div>
			</form>
		</ReportPanel>
	);
};

export default BookMetricsExportPanel;
